export default __webpack_public_path__ + "static/media/new-tlc-drivers-license.2cd98dea.png";